(function() {
    'use strict';

    angular.module('caffeprint')
        .controller('FooterController', FooterController);

    FooterController.$inject = [];

    function FooterController() {
        var self = this;
    }
})();
